import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Loading = ({ className }) => (
  <div className={className}>
    <CircularProgress />
  </div>
);

Loading.propTypes = { className: PropTypes.string.isRequired };

export default styled(Loading)`
  text-align: center;
  width: 100%;
  margin: 1rem;
`;
